import {
  Row,
  Col,
  Card,
  Button,
  Typography,
  Modal,
  Table,
  Pagination,
  Input,
} from "antd";
import { useEffect, useState } from "react";
import { getUsersAPI } from "../api/users";
import constant from "../config/constant";
import { RocketFilled } from "@ant-design/icons";
import { getDevicesAPI, deleteDeviceAPI } from "../api/devices";

const { Title } = Typography;
const { Search } = Input;
function Users() {
  const [users, setUsers] = useState([]);
  const [devices, setDevices] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  useEffect(() => {
    _getUsers();
  }, []);

  const _getUsers = async (page = 1, pageSize = 10, search = "") => {
    setLoading(true);
    try {
      const params = {
        page: page,
        limit: pageSize,
      };

      if (search.trim()) {
        params.name = search;
      }

      const res = await getUsersAPI(params);
      if (res?.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        setUsers(res?.data?.users || []);
        setPagination((prev) => ({
          ...prev,
          total: res?.data?.totalUsers || 0,
        }));
      }
    } catch (e) {
      console.log("Error", e);
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = (value) => {
    setSearchQuery(value);
    setPagination((prev) => ({
      ...prev,
      current: 1,
    }));
    _getUsers(1, pagination.pageSize, value);
  };

  const getDevices = async (id) => {
    console.log("🚀 ~ getDevices ~ id:", id);
    try {
      const res = await getDevicesAPI({ user_id: id });
      if (res?.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        setDevices(res?.data?.records || []);
        setSelectedUser(id); // Set selected user
        setIsModalVisible(true); // Open the modal
      }
    } catch (e) {
      console.log("Error", e);
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false); // Close modal
    setDevices([]); // Clear devices list
    setSelectedUser(null); // Clear selected user
  };

  const handleDeleteDevice = async (deviceId) => {
    console.log("🚀 ~ handleDeleteDevice ~ deviceId:", deviceId);
    try {
      const res = await deleteDeviceAPI(deviceId);
      if (res?.statusCode === constant.RESPONSE_CODE.SUCCESS) {
        // Refresh the devices list after deletion
        getDevices(selectedUser);
      }
    } catch (e) {
      console.log("Error deleting device:", e);
    }
  };

  // Columns for devices table in modal
  const deviceColumns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      align: "center",
      render: (text, record, index) => index + 1, // Display the index starting from 1
    },
    {
      title: "Device ID",
      dataIndex: "id",
      key: "id",
      align: "center",
    },
    {
      title: "Device Name",
      dataIndex: "device_name",
      key: "device_name",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "device_connection_state",
      key: "device_connection_state",
      align: "center",
      render: (text) => (
        <span style={{ color: text === "connected" ? "green" : "red" }}>
          {text === "connected" ? "Connected" : "Disconnected"}
        </span>
      ),
    },
    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Button
          type="primary"
          danger
          onClick={() => handleDeleteDevice(record.id)}
        >
          Delete
        </Button>
      ),
    },
  ];

  return (
    <>
      <div className="tabled">
        <Row gutter={[24, 0]}>
          <Col xs="24" xl={24}>
            <Card
              bordered={false}
              className="criclebox tablespace mb-24"
              title={`Figo Users (${
                (pagination.current - 1) * pagination.pageSize + 1
              }-${Math.min(
                pagination.current * pagination.pageSize,
                pagination.total
              )}/${pagination.total})`}
              extra={
                <Search
                  placeholder="Search by name"
                  allowClear
                  enterButton="Search"
                  style={{ width: 300 }}
                  onSearch={handleSearch}
                  className="custom-search"
                />
              }
            >
              <div className="ant-list-box table-responsive m-25">
                <table className="width-100">
                  <thead>
                    <tr>
                      <th>
                        <div className="text-center">ID</div>
                      </th>
                      <th>
                        <div className="text-center">Name</div>
                      </th>
                      <th>
                        <div className="text-center">Email</div>
                      </th>
                      <th>
                        <div className="text-center">is Verified</div>
                      </th>
                      <th>
                        <div className="text-center">Device</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {users.map((d, index) => (
                      <tr key={index}>
                        <td>
                          <div className="text-xs text-center">{d?.id}</div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            <Title level={5}>{d?.full_name}</Title>
                          </div>
                        </td>
                        <td>
                          <div className="text-xs text-center">{d?.email}</div>
                        </td>
                        <td>
                          <div className="text-xs text-center">
                            {d?.is_email_verified ? "Yes" : "No"}
                          </div>
                        </td>
                        <td>
                          <div
                            className="col-action text-right"
                            style={{ justifyContent: "center" }}
                          >
                            <Button
                              type="dashed"
                              className="darkbtn"
                              onClick={() => getDevices(d?.id)}
                            >
                              <RocketFilled style={{ fontSize: "16px" }} />
                              Devices
                            </Button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div
                style={{
                  marginTop: 16,
                  textAlign: "right",
                  marginBottom: 20,
                  marginRight: 20,
                }}
              >
                <Pagination
                  current={pagination.current}
                  pageSize={pagination.pageSize}
                  total={pagination.total}
                  onChange={(page, pageSize) => {
                    setPagination((prev) => ({
                      ...prev,
                      current: page,
                      pageSize: pageSize,
                    }));
                    _getUsers(page, pageSize, searchQuery);
                  }}
                  showSizeChanger
                  showTotal={(total, range) =>
                    `${range[0]}-${range[1]} of ${total} items`
                  }
                />
              </div>
            </Card>
          </Col>
        </Row>
      </div>

      {/* Modal for displaying devices */}
      <Modal
        title={`Devices for User ID: ${selectedUser}`}
        visible={isModalVisible}
        onCancel={handleCancel}
        width={800}
        footer={[
          <Button key="close" onClick={handleCancel}>
            Close
          </Button>,
        ]}
      >
        <Table
          dataSource={devices}
          columns={deviceColumns}
          rowKey={(record) => record.device_id}
          pagination={false}
        />
      </Modal>

      <style>
        {`
          .custom-search .ant-input-search-button {
            height: 50px !important;
            background: #000 !important;
            border-color: #000 !important;
          }
          .custom-search .ant-input {
            height: 50px !important;
          }
          .custom-search .ant-input-group-addon {
            height: 50px !important;
          }
          .custom-search .ant-input-clear-icon {
            top: 17px;
          }
        `}
      </style>
    </>
  );
}

export default Users;
